import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, createStaticVNode as _createStaticVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "line-chart" }
const _hoisted_2 = /*#__PURE__*/_createStaticVNode("<h1>Line Chart</h1><p> To create a line chart in <b>vue3-charts</b> you can use the <code>Line</code> layer. You can add the <code>Line</code> layer multiple times or combine it with other layers (<code>Bar</code>, <code>Area</code>). </p><p>Here you can see a simple example using two <code>Line</code> layers.</p>", 3)
const _hoisted_5 = /*#__PURE__*/_createElementVNode("h2", { class: "mt-6" }, "Line Props", -1)
const _hoisted_6 = /*#__PURE__*/_createElementVNode("p", null, "The line layer allows a number of properties to be specified.", -1)
const _hoisted_7 = /*#__PURE__*/_createElementVNode("div", { class: "mb-2" }, "Use lineStyle to set svg styling for the line.", -1)
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "font-bold" }, "Ex:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("ul", { class: "list-disc list-inside" }, [
  /*#__PURE__*/_createElementVNode("li", null, "stroke (ex. red)"),
  /*#__PURE__*/_createElementVNode("li", null, "strokeWidth"),
  /*#__PURE__*/_createElementVNode("li", null, "strokeLinecap"),
  /*#__PURE__*/_createElementVNode("li", null, "strokeDasharray")
], -1)
const _hoisted_10 = /*#__PURE__*/_createTextVNode(" Same as ")
const _hoisted_11 = /*#__PURE__*/_createElementVNode("code", null, "lineStyle", -1)
const _hoisted_12 = /*#__PURE__*/_createTextVNode(" but applyes to line dot. ")
const _hoisted_13 = /*#__PURE__*/_createElementVNode("div", null, "What data the line to render.", -1)
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", null, [
  /*#__PURE__*/_createTextVNode("Ex: "),
  /*#__PURE__*/_createElementVNode("code", null, "['name', 'pl']")
], -1)
const _hoisted_15 = /*#__PURE__*/_createTextVNode(" Set how to draw the line. ")

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_LineChart = _resolveComponent("LineChart")!
  const _component_ChartBlock = _resolveComponent("ChartBlock")!
  const _component_Prop = _resolveComponent("Prop")!
  const _component_PropsBlock = _resolveComponent("PropsBlock")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createVNode(_component_ChartBlock, {
      chartCode: _ctx.code.chartCode,
      dataCode: _ctx.code.dataCode
    }, {
      default: _withCtx(() => [
        _createVNode(_component_LineChart)
      ]),
      _: 1
    }, 8, ["chartCode", "dataCode"]),
    _hoisted_5,
    _hoisted_6,
    _createVNode(_component_PropsBlock, { class: "mt-4" }, {
      default: _withCtx(() => [
        _createVNode(_component_Prop, {
          name: "lineStyle",
          types: ['Object']
        }, {
          default: _withCtx(() => [
            _hoisted_7,
            _hoisted_8,
            _hoisted_9
          ]),
          _: 1
        }),
        _createVNode(_component_Prop, {
          name: "dotStyle",
          types: ['Object'],
          odd: ""
        }, {
          default: _withCtx(() => [
            _hoisted_10,
            _hoisted_11,
            _hoisted_12
          ]),
          _: 1
        }),
        _createVNode(_component_Prop, {
          name: "dataKeys",
          types: ['Array']
        }, {
          default: _withCtx(() => [
            _hoisted_13,
            _hoisted_14
          ]),
          _: 1
        }),
        _createVNode(_component_Prop, {
          name: "type",
          types: ['normal', 'step', 'natural', 'monotone'],
          odd: ""
        }, {
          default: _withCtx(() => [
            _hoisted_15
          ]),
          _: 1
        })
      ]),
      _: 1
    })
  ]))
}